<template>
  <div>
    <Header />
    <router-view />
    <Footer />
  </div>
</template>
<script>
import Header from '@/components/web/header/index.vue';
import Footer from '@/components/web/footer/index.vue';

export default {
  components: {
    Footer,
    Header
  }
}
</script>

<style lang="scss">
@import "assets/scss/main";
</style>
